import { ClickHandlerProps, Photo, RowsPhotoAlbum } from 'react-photo-album';
import 'react-photo-album/rows.css';
import useScreenSize from 'hooks/useScreenSize';
import PhotoSquare from 'icons/PhotoSquare';
import { MouseEvent, useState, Fragment } from 'react';
import { usePhotoGalleryContainer } from '..';
import styles from './styles/PhotoGalleryRowAlbum.module.scss';
import Image from 'components/Image';
import MinuteMediaAd from '@/components/ads/MinuteMediaAd';
import chunkArray from 'helpers/chunkArray';

export const PREVENT_DEFAULT = (e: MouseEvent<HTMLDivElement | HTMLImageElement>) => e.preventDefault();

const PHOTO_SPACING = 5;
const PHOTO_ROW_HEIGHT = 300;
const PHOTOS_PER_SECTION = 8;

export default function PhotoGalleryRowAlbum() {
  const [{ photoGallery }, { handleThumbnailClick }] = usePhotoGalleryContainer();
  const [hoveredIndex, setHoveredIndex] = useState<Number>();
  const { isSmallScreen } = useScreenSize();

  const rowAlbumPhotos: Photo[] = photoGallery.photos.map(photo => {
    return {
      src: photo.s3Watermark ?? photo.watermark,
      width: +photo.uploadedWidth,
      height: +photo.uploadedHeight,
      alt: photo.filename
    };
  });

  const albumSections = chunkArray(rowAlbumPhotos, PHOTOS_PER_SECTION);

  return (
    <div onContextMenu={PREVENT_DEFAULT}>
      {albumSections.map((section, sectionIndex) => {
        const sectionStartIndex = albumSections.slice(0, sectionIndex).reduce((sum, section) => sum + section.length, 0);

        return (
          <Fragment key={sectionIndex}>
            <RowsPhotoAlbum
              photos={section}
              onClick={({ index }: ClickHandlerProps) => handleThumbnailClick(sectionStartIndex + index)}
              render={{
                photo: ({ onClick }, { photo, width, height, index }) => (
                  <div
                    key={`photo-thumbnail-${photo.alt}`}
                    className={styles.ThumbnailContainer}
                    onMouseEnter={() => setHoveredIndex(sectionStartIndex + index)}
                    onMouseLeave={() => setHoveredIndex(undefined)}
                  >
                    <Image src={photo.src} alt={photo.alt} width={width} height={height} onClick={onClick} />
                    {hoveredIndex === sectionStartIndex + index && !isSmallScreen && (
                      <div className={styles.IconOverlay} onClick={onClick}>
                        <PhotoSquare />
                      </div>
                    )}
                  </div>
                )
              }}
              spacing={PHOTO_SPACING}
              targetRowHeight={PHOTO_ROW_HEIGHT}
              skeleton={<div style={{ width: '100%', minHeight: 400 }} />}
            />
            {sectionIndex < albumSections.length - 1 && <MinuteMediaAd placement={`IN_FEED`} className={styles.RowAlbumAd} />}
          </Fragment>
        );
      })}
    </div>
  );
}
